import { getEditLocation } from "../../../core/util/functions";
export const marginsDataLocation = "/cliring/marginscalculation";
export const getMarginsDataEditLocation = (id?: string) =>
  getEditLocation(marginsDataLocation, undefined, id);

export const editRouter = getMarginsDataEditLocation(":ptdId?");
